import BillingType from "@/domain/entities/organization/BillingType";
import Organization from "@/domain/entities/organization/Organization";
import OrganizationLicense, {
    OrganizationLicenseUser,
} from "@/domain/entities/organization/OrganizationLicense";
import OrganizationUser from "@/domain/entities/organization/OrganizationUser";
import {
    BillingType as BillingTypeSDK,
    LicenseAffectation as LicensedUserSDK,
    ListAllUsersAndLicenceResponse,
    OrganizationLicense as OrganizationLicenseSDK,
    OrganizationResponse as OrganizationResponseSDK,
} from "@cs_teamwaydev/mailvista-sdk_react";

type OrganizationUserSDK = ListAllUsersAndLicenceResponse[number];

const mapBillingType = (sdkBillingType: BillingTypeSDK): BillingType => {
    const mapping: Record<string, BillingType> = {
        [BillingTypeSDK.Direct]: BillingType.Direct,
        [BillingTypeSDK.Indirect]: BillingType.Indirect,
        [BillingTypeSDK.Stores]: BillingType.Stores,
    };

    return mapping[sdkBillingType] ?? BillingType.Direct;
};

const organizationLicenseUser = (
    licensedUser: LicensedUserSDK,
): OrganizationLicenseUser => ({
    instanceId: licensedUser.instanceId,
    status: licensedUser.status,
    mail: licensedUser.userMail || null,
});

const organizationLicenseMapper = (
    organizationLicense: OrganizationLicenseSDK,
): OrganizationLicense =>
    new OrganizationLicense({
        id: organizationLicense.id,
        name: organizationLicense.licenseId,
        licenseId: organizationLicense.licenseId,
        licenseCount: organizationLicense.licenseCount,
        billingType: mapBillingType(
            organizationLicense.billingType as BillingTypeSDK,
        ),
        users: organizationLicense.licensesAffectation.map(
            organizationLicenseUser,
        ),
    });

export const organizationMapper = (
    organization: OrganizationResponseSDK,
): Organization =>
    new Organization({
        id: organization.id,
        name: organization.name,
        adminEmails: organization.organizationAdmins,
        licenses: organization.organizationLicenses.map(
            organizationLicenseMapper,
        ),
    });

export const organizationUserMapper = (
    organizationUser: OrganizationUserSDK,
): OrganizationUser =>
    new OrganizationUser({
        id: organizationUser.userId,
        displayName: organizationUser.displayName,
        isMonthlyAnalyzedMailLimitReached:
            organizationUser.isMonthlyAnalyzedMailLimitReached,
        mail: organizationUser.mail,
        license: organizationUser.activeLicense
            ? {
                  id: organizationUser.activeLicense.id,
                  licenseId: organizationUser.activeLicense.licenseId,
              }
            : undefined,
    });
